export enum ImportType {
  file = "file",
  sync = "sync",
  manual = "manual",
}
